import React from "react";
import { HubTableHeader } from "../../HubTable";

const headCells = [
  {
    id: "barcodes",
    label: "Barcodes",
  },
  {
    id: "name",
    label: "Name",
  },
];

const BarcodesTableHeader = () => {
  const tableRowProps = {
    sx: {
      th: {
        padding: "0px 5px !important",
        height: "15.3px !important",
        div: {
          fontSize: "10px !important",
        },
      },
    },
  };

  return (
    <HubTableHeader
      items={headCells}
      includeCheckbox={false}
      includeEnd={false}
      tableRowProps={tableRowProps}
    />
  );
};

export default BarcodesTableHeader;
